import { API } from 'aws-amplify'
import { optionsForSurvey } from './ServiceHelper'

export const loadResultsSurveys = () =>
  API.get('ResultsAPI', '/surveys', optionsForSurvey())
